<template>
<div class="vx-col md:w-full w-full mb-base">
    <vx-card>
        <h4> <b> {{usuario[0].nombre}}, </b> gracias por usar nuestro sistema, nos vemos pronto. </h4>
        <div class="m-5">
            <vs-button color="danger" icon-pack="feather" icon="icon-log-out" @click="f_salir()"> Cerrar </vs-button>
        </div>
    </vx-card>
</div>
</template>

<script>
export default {
    data() {
        return {
            usuario: [],
        }
    },
    mounted() {
        this.usuario = JSON.parse(localStorage.getItem('usuario'));
    },
    methods: {
        f_salir() {
            let me = this;
            // localStorage.removeItem('token');
            // localStorage.removeItem('usuario');
            localStorage.clear()
            me.$router.push('/');
        }
    }
}
</script>
